import { useTranslation } from 'react-i18next'
import { GetTodos } from '../../graphql/queries'
import { useQuery } from '@apollo/client'
import { TodoStatuses } from '../../util/const'
import './style.scss'
import { useState } from 'react'
import AddTodoModal from '../../components/AddTodoModal'
import UpdateTodoModal from '../../components/UpdateTodoModal'
import ToDoColumn from '../../components/ToDoColumn'

const TodosScreen = () => {
    const { t } = useTranslation()
    const [showAddModal, setShowAddModal] = useState(false)
    const [showUpdateModal, setShowUpdateModal] = useState(false)
    const [selectedStatus, setSelectedStatus] = useState(null)
    const [selectedTodo, setSelectedTodo] = useState(null)

    const { data, loading } = useQuery(GetTodos, {
        fetchPolicy: 'no-cache',
        pollInterval: 60 * 1000,
    })

    return (
        <div className='todos'>
            <div className='inner'>
                <div className='inner-title'>
                    <h2>{t('To-do')}</h2>
                </div>
                <div className='todos-list'>
                    {
                        TodoStatuses.map((status) => (
                            <ToDoColumn
                                key={status.value}
                                status={status}
                                items={data?.getTodos?.filter((todo) => todo.STATUS === status.value)}
                                onItemPress={(todo) => {
                                    setSelectedTodo(todo)
                                    setShowUpdateModal(true)
                                }}
                                loading={loading}
                                onAddClick={() => {
                                    setSelectedStatus(status.value)
                                    setShowAddModal(true)
                                }}
                            />
                        ))
                    }
                </div>
            </div>
            <AddTodoModal
                show={showAddModal}
                close={() => setShowAddModal(false)}
                selectedStatus={selectedStatus}
            />
            <UpdateTodoModal
                show={showUpdateModal}
                close={() => setShowUpdateModal(false)}
                data={selectedTodo}
            />
        </div>
    )
}

export default TodosScreen